import { useState } from "react";
import { Grid, Typography } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useUser } from "../../contexts/UserContext";
import { formatNumber, formatDate } from "../../Utils/utils";
import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";
import { DataGridTable } from "../Table";
import {isTestEnv} from "../../globals";

export const Obligo = ({ obligo, obligoPerBranch }) => {
  const [expandedPanel, setExpandedPanel] = useState(false);
  const handleChange = (event, isExpanded) => {
    setExpandedPanel(isExpanded);
  };
  const { user } = useUser();
  isTestEnv && console.log("Obligo", obligo);
  isTestEnv && console.log("obligoPerBranch", obligoPerBranch);

  const dataGridColumns = [
    {
      field: "BRANCHDES",
      headerName: "שם הסניף",
      cellClassName: "first-column",
    },
    {
      field: "ORD_DEBIT",
      headerName: "הזמנות פתוחות",
      renderCell: (params) => formatNumber(params.value),
    },
    {
      field: "DOC_DEBIT_IV_DEBIT",
      headerName: "תעודות שלא חויבו",
      renderCell: (params) => formatNumber(params.value),
    },
    {
      field: "OBLIGO",
      headerName: 'סה"כ אובליגו',
      renderCell: (params) => formatNumber(params.value),
    },
    {
      field: "OBLIGO_REST",
      headerName: "יתרת אובליגו",
      renderCell: (params) => {
        const value = params.value;
        const color = value < 0 ? "#FF5733" : value > 0 ? "#4CAF50" : null;
        return <span style={{ color }}>{formatNumber(value)}</span>;
      },
    },
    {
      field: "MAX_OBLIGO",
      headerName: "תיקרת אובליגו",
      renderCell: (params) => formatNumber(params.value),
    },
    {
      field: "ACC_DEBIT",
      headerName: "חוב פתוח",
      renderCell: (params) => formatNumber(params.value),
    },
    {
      field: "OBLIGOBRANCH_FNCITEM",
      headerName: "תעודות חיוב מתוך חוב פתוח",
      renderCell: (params) => formatNumber(params.value),
    },
    {
      field: "FUTURE",
      headerName: "חוב שוטף",
      renderCell: (params) => formatNumber(params.value),
    },
    {
      field: "UPTO30",
      headerName: "חוב בין 1-30",
      renderCell: (params) => formatNumber(params.value),
    },
    {
      field: "UPTO60",
      headerName: "חוב בין 31-60",
      renderCell: (params) => formatNumber(params.value),
    },
    {
      field: "UPTO90",
      headerName: "חוב בין 61-90",
      renderCell: (params) => formatNumber(params.value),
    },
    {
      field: "OLD",
      headerName: "חוב מעל 90",
      renderCell: (params) => formatNumber(params.value),
    },
  ];
  // Filter the appropriate branches according to defined conditions, Add unique id to each row, calculate DOC_DEBIT_IV_DEBIT and OBLIGOBRANCH_FNCITEM
  const OPerBranch = obligoPerBranch?.map((row, index) => ({
      ...row,
      id: index,
      DOC_DEBIT_IV_DEBIT: row.DOC_DEBIT + row.IV_DEBIT,
      OBLIGOBRANCH_FNCITEM: row.OBLIGOBRANCH_FNCITEM_SUBFORM.filter(item => item.SUM1 > 0 && item.FNCPATNAME !== "חל" && item.FNCPATNAME !== "חלמ").reduce(
        (total, debt) => total + debt.SUM1,
        0
      ),
    }));
    isTestEnv && console.log("OPerBranch", OPerBranch);
  const textFields = [
    {
      "הזמנות פתוחות": formatNumber(obligo?.ORD_DEBIT).toLocaleString(),
      "תעודות שלא חויבו": isNaN(obligo?.DOC_DEBIT + obligo?.IV_DEBIT)
        ? ""
        : (obligo?.DOC_DEBIT + obligo?.IV_DEBIT).toLocaleString(),
      "חוב פתוח": formatNumber(obligo?.ACC_DEBIT),
    },
    {
      "סה״כ אובליגו": formatNumber(obligo?.OBLIGO),
      "יתרת אובליגו":
        obligo?.OBLIGO_REST !== undefined
          ? formatNumber(obligo.OBLIGO_REST).toLocaleString()
          : null,
      "תיקרת אובליגו":
        obligo?.MAX_OBLIGO !== undefined
          ? formatNumber(obligo?.MAX_OBLIGO).toLocaleString()
          : null,
    },
    {
      "אחוז ניצול האובליגו":
        obligo?.NEO_PERCENT !== undefined
          ? obligo.NEO_PERCENT.toLocaleString(undefined, {
              maximumFractionDigits: 0,
            })
          : null,
      "תאריך החישוב":
        obligo?.CURDATE !== undefined ? formatDate(obligo.CURDATE) : null,
      "המחאות דחויות": formatNumber(obligo?.CHEQUE_DEBIT).toLocaleString(),
    },
  ];

  return (
    <Accordion expanded={expandedPanel} onChange={handleChange} disabled={obligo===null && obligoPerBranch===null}>
      <AccordionSummary
        expandIcon={<ArrowDropDownIcon />}
        aria-controls="panel-content"
        id="panel-header"
        style={{
          backgroundColor: expandedPanel ? "#f0f0f0" : "inherit",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "5px",
            borderRadius: "5px",
          }}
        >
          <span
            style={{
              fontWeight: "bold",
              fontSize: "1.2rem",
            }}
          >
            {(user?.userBranchesList?.length === 0 && obligo) || OPerBranch?.length === 0
              ? "אובליגו לקוח"
              : "אובליגו לקוח לסניף"}
          </span>
          {/* in case of the user list branches is empty, that it, he has permissions to see all the branches */}
          {user?.userBranchesList?.length === 0 && obligo && (
            <div style={{ display: "flex", alignItems: "center" }}>
              <div style={{ marginRight: "40px" }}>
                <span style={{ fontWeight: "bold", fontSize: "1rem" }}>
                  סה"כ אובליגו:{" "}
                </span>
                <span>
                  {obligo?.OBLIGO !== undefined
                    ? formatNumber(obligo?.OBLIGO)
                    : null}
                </span>
              </div>
              <div style={{ marginRight: "60px" }}>
                <span style={{ fontWeight: "bold", fontSize: "1rem" }}>
                  יתרת אובליגו:{" "}
                </span>
                <span
                  style={{
                    color:
                      obligo?.OBLIGO_REST < 0
                        ? "#FF5733"
                        : obligo?.OBLIGO_REST > 0
                        ? "#4CAF50"
                        : null,
                  }}
                >
                  {formatNumber(obligo?.OBLIGO_REST).toLocaleString()}
                </span>
              </div>
            </div>
          )}
        </div>
      </AccordionSummary>
      {obligo === undefined &&
      OPerBranch?.length === 0 ? (
        <Alert severity="info">אין אובליגו ללקוח</Alert>
      ) : (
        <div>
          <AccordionDetails>
                {user?.userBranchesList?.length === 0 && obligo && (
                <Grid container spacing={2}>
                  {[...Array(3)].map((_, index) => {
                    let keys = Object.keys(textFields[index]);
                    return (
                      <Grid item xs={4} key={index}>
                        <Grid container direction="column" spacing={2}>
                          {[...Array(3)].map((_, innerIndex) => (
                            <Grid item key={innerIndex}>
                              <TextField
                                label={keys[innerIndex]}
                                variant="standard"
                                value={textFields[index][keys[innerIndex]]}
                                fullWidth
                                inputProps={{
                                  style: {
                                    color:
                                      keys[innerIndex] === "יתרת אובליגו"
                                        ? obligo?.OBLIGO_REST < 0
                                          ? "#FF5733"
                                          : obligo?.OBLIGO_REST >= 0
                                          ? "#4CAF50"
                                          : null
                                        : keys[innerIndex] ===
                                          "אחוז ניצול האובליגו"
                                        ? obligo?.NEO_PERCENT > 100
                                          ? "#FF5733"
                                          : obligo?.NEO_PERCENT < 100
                                          ? "#4CAF50"
                                          : null
                                        : null,
                                  },
                                }}
                                InputLabelProps={{ shrink: true }}
                                InputProps={{ readOnly: true }}
                              />
                            </Grid>
                          ))}
                        </Grid>
                      </Grid>
                    );
                  })}

                  <Typography
                    style={{
                      fontWeight: "bold",
                      fontSize: "1.1rem",
                      marginRight: "3%",
                      marginTop: "3%",
                      display: "inline",
                    }}
                  >
                    אובליגו לקוח לסניף
                  </Typography>
                </Grid>
              )}
          </AccordionDetails>
          {OPerBranch?.length === 0 ? (
            <Alert severity="info">אין אובליגו ללקוח לפי סניפים</Alert>
          ) : (
            <div>
              <AccordionDetails>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography>
                      {dataGridColumns !== "undefined" && (
                        <DataGridTable
                          columns={dataGridColumns}
                          rows={OPerBranch}
                        />
                      )}
                    </Typography>
                  </Grid>
                </Grid>
              </AccordionDetails>
            </div>
          )}
        </div>
      )}
    </Accordion>
  );
};